class CollectionSearch extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('[data-collection-search-input]');
    this.clearBtn = this.querySelector('[data-collection-search-clear]');
    this.status = this.querySelector('[data-collection-search-status]');
    this._query = '';
    this._onInput = this.onInput.bind(this);
    this._onClear = this.clear.bind(this);
    this._onGridUpdated = this.onGridUpdated.bind(this);

    if (this.input) {
      this.input.addEventListener('input', this._onInput);
      this.input.addEventListener('search', this._onInput);
    }
    if (this.clearBtn) {
      this.clearBtn.addEventListener('click', this._onClear);
    }
    this.syncClearTabIndex();
    document.addEventListener('collection:products-updated', this._onGridUpdated);
  }

  disconnectedCallback() {
    if (this.input) {
      this.input.removeEventListener('input', this._onInput);
      this.input.removeEventListener('search', this._onInput);
    }
    if (this.clearBtn) {
      this.clearBtn.removeEventListener('click', this._onClear);
    }
    document.removeEventListener('collection:products-updated', this._onGridUpdated);
  }

  onInput() {
    this._query = (this.input?.value || '').trim().toLowerCase();
    this.syncClearTabIndex();
    this.filter();
    this.maybeLoadMore();
  }

  onGridUpdated() {
    this.filter();
    this.maybeLoadMore();
  }

  clear() {
    if (this.input) this.input.value = '';
    this._query = '';
    this.syncClearTabIndex();
    this.filter();
    this.input?.focus();
  }

  syncClearTabIndex() {
    if (!this.clearBtn) return;
    const hasValue = Boolean(this.input?.value);
    this.clearBtn.tabIndex = hasValue ? 0 : -1;
    this.clearBtn.setAttribute('aria-hidden', hasValue ? 'false' : 'true');
  }

  getCards() {
    return document.querySelectorAll('#ProductsList .card');
  }

  cardMatches(card, query) {
    if (!query) return true;
    const product = card.querySelector('[data-product-card]');
    const haystack = [
      product?.dataset?.search,
      product?.dataset?.ref,
      product?.dataset?.insp,
      card.textContent,
    ]
      .filter(Boolean)
      .join(' ')
      .toLowerCase();
    return haystack.includes(query);
  }

  filter() {
    const query = this._query;
    const cards = this.getCards();
    let visible = 0;

    cards.forEach((card) => {
      const match = this.cardMatches(card, query);
      card.hidden = !match;
      card.classList.toggle('is-search-hidden', !match);
      if (match) visible += 1;
    });

    this._visible = visible;

    if (this.status) {
      if (!query) {
        this.status.hidden = true;
        this.status.textContent = '';
      } else {
        this.status.hidden = false;
        this.status.textContent =
          visible === 0
            ? 'Aucun résultat'
            : visible === 1
              ? '1 résultat'
              : `${visible} résultats`;
      }
    }

    document
      .getElementById('ProductGridContainer')
      ?.classList.toggle('collection-search--empty', Boolean(query) && visible === 0);
  }

  maybeLoadMore() {
    if (!this._query) return;
    // Keep fetching while searching so matches beyond the first page appear.
    if ((this._visible || 0) > 8) return;

    const trigger = document.querySelector(
      '#ProductGridContainer [is="load-more-button"], #ProductGridContainer load-more-button'
    );
    if (!trigger || trigger._loading || trigger.classList.contains('btn--loading')) return;
    if (!trigger.getAttribute('data-action') && !trigger.getAttribute('action') && !trigger.href) {
      // infinite triggers still expose action via attributes after render
    }

    if (typeof trigger.onClick === 'function') {
      trigger.onClick();
    } else {
      trigger.click();
    }
  }
}

customElements.define('collection-search', CollectionSearch);
